import { defineStore } from "pinia";
import { useCookies } from 'vue3-cookies';

export const filterStore = defineStore('filter', {
    state: () => ({
        // query_string: "",
        query_area: "",
        query_location: "",
        query_sublocation: "",
        query_kontraktor: "",
        query_synonym: false,
        query_translate: false,
        query_period: [],
        // list_area: [],
        // list_location: [],
        // list_sublocation: [],
        // list_kontraktor: [],
        key: "",
    }),
    actions: {
        loadFromCookie() {
            const vc = useCookies().cookies;
            let filter = vc.get("filter");

            // console.log("Raw cookie before parsing:", filter); // Debug log

            // Clean the string to remove anything after the first closing brace (})
            let rawFilter = filter;
            const cleanedFilter = rawFilter.match(/^\{.*\}/);  // Get the part up to and including the first '}'
            // console.log("Cleaned filter:", cleanedFilter);  // Debug log to check cleaned filter

            try {
                // Try parsing the cleaned string
                filter = JSON.parse(cleanedFilter);
                // console.log("Parsed filter:", filter);
            } catch (error) {
                console.error("Error parsing cookie:", error);
                filter = null; // Reset to null if parsing fails
            }

            // If filter is valid, print the values
            if (filter) {
                for (const key in filter) {
                    if (filter.hasOwnProperty(key)) {
                        console.log(`${key}: ${filter[key]}`);
                    }
                }

                // You can continue with other operations to update the state
                // Example:
                for (const key in filter) {
                    // Here, you can update your state with the values from the filter object
                    // Example: 
                    if (this.$state[key] !== undefined) {
                        this.$state[key] = filter[key];
                        // console.log(`${key} updated in state:`, this.$state[key]);
                    }
                }

                // console.log("State after loading from cookie:", this.$state); // Debug log to confirm state update
            } else {
                console.log("Filter is null or invalid.");
            }
        },
        set(filter) {
            for (const key in filter) {
                if (key in this.$state && !key.includes("list_")) {
                    // console.log("filter[key]", filter[key])
                    this.$state[key] = filter[key];
                }
            }

            const vc = useCookies().cookies;
            const expirationDate = new Date();
            expirationDate.setDate(expirationDate.getDate() + 7);

            // Save the updated state to cookies
            vc.set("filter", JSON.stringify(this.$state), {
                expires: expirationDate,
                secure: false, // Use `false` for testing on HTTP
                path: "/",      // Ensure the cookie is accessible on all routes
            });
        },
        clear() {
            const vc = useCookies().cookies;
            // Reset the state and clear the cookie
            this.$reset(); // Reset the state to its default values
            vc.set("filter", "", { expires: new Date(0) }); // Expire immediately
            console.log("Cleared state and cookie");
        },
    },
});
